import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-white/10 bg-coal px-4 py-3.5 text-[15px] text-white outline-none transition placeholder:text-white/30 focus:border-gold focus:ring-2 focus:ring-gold/30";

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-5">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-sm">
        <img src="/assets/singh-taxi-logo.png" alt="Singh Taxi" className="h-14 w-auto rounded-md" />
        <div className="mt-8 flex items-center gap-3">
          <span className="h-px w-8 bg-gold/80" />
          <span className="text-xs font-bold tracking-[0.3em] text-gold">OWNER DASHBOARD</span>
        </div>
        <h1 className="mt-4 font-serif text-4xl text-white">Sign in</h1>
        <div className="mt-8 space-y-4">
          <input
            data-testid="admin-login-email"
            type="email"
            required
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
          />
          <input
            data-testid="admin-login-password"
            type="password"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
          />
        </div>
        {error && (
          <p data-testid="admin-login-error" className="mt-4 text-sm font-semibold text-red-400">
            {error}
          </p>
        )}
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={busy}
          className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-gold px-6 py-4 text-base font-extrabold text-black transition-all hover:-translate-y-0.5 hover:bg-gold-light disabled:opacity-70"
        >
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Lock className="h-5 w-5" />}
          Sign in
        </button>
      </form>
    </div>
  );
}
